import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SENTIMENTS, TOPICS } from 'src/app/views/apps/news-analyzer/utils';
import { DialogRectifySentimentComponent } from '../dialog-rectify-sentiment/dialog-rectify-sentiment';
import { DialogRectifyTopicComponent } from '../dialog-rectify-topic/dialog-rectify-topic';


@Component({
    selector: 'app-comments-explorer',
    templateUrl: 'comments-explorer.component.html',
    styleUrls: ["./comments-explorer.component.css"]
})
export class CommentsExplorerComponent implements OnInit, OnChanges {
    @Input() dataSource: { position, text, sentiment, topic }[] = []
    @Input() token = ''

    filteredDatasource: { position, text, sentiment, topic }[]
    displayedColumns = ['number', 'text', 'sentiment', 'wrong_sentiment', 'topic', 'wrong_topic']
    facetedData = {
        selectedSentiment: '',
        selectedTopic: '',
        showedTopics: [],
        showedSentiments: [],
        listOfTopics: TOPICS.map(topic => ({ name: topic })),
        listOfSentiments: SENTIMENTS.map(sentiment => ({ name: sentiment }))
    }

    constructor(private _snackBar: MatSnackBar, public dialog: MatDialog) { }

    ngOnChanges(changes: SimpleChanges): void {
        this.filteredDatasource = this.dataSource
        this.facetedUpdatedShownData()
    }

    ngOnInit() {
        this.filteredDatasource = this.dataSource
        this.facetedUpdatedShownData()
    }

    facetedSelectSentiment(sentiment: string) {
        this.facetedData.selectedSentiment = sentiment
        this.facetedUpdatedShownData()
    }

    facetedRemoveSentiment() { this.facetedSelectSentiment('') }

    facetedRemoveTopic() { this.facetedSelectTopic('') }

    facetedSelectTopic(topic: string) {
        this.facetedData.selectedTopic = topic
        this.facetedUpdatedShownData()
    }

    facetedUpdatedShownData() {
        this.filteredDatasource = this.dataSource.filter(row => {
            if (row.sentiment !== this.facetedData.selectedSentiment
                && this.facetedData.selectedSentiment !== '') return false
            if (row.topic !== this.facetedData.selectedTopic
                && this.facetedData.selectedTopic !== '') return false
            return true
        })
        this.facetedData.showedSentiments = []
        this.facetedData.showedTopics = []
        this.filteredDatasource.forEach(row => {
            // Update sentiments stats
            const idxSentiment = this.facetedData.showedSentiments.findIndex(item => item.name === row.sentiment)
            if (idxSentiment === -1)
                this.facetedData.showedSentiments.push({ name: row.sentiment, amount: 1 })
            else
                this.facetedData.showedSentiments[idxSentiment].amount += 1

            // Update topics stats
            const idxTopic = this.facetedData.showedTopics.findIndex(item => item.name === row.topic)
            if (idxTopic === -1)
                this.facetedData.showedTopics.push({ name: row.topic, amount: 1 })
            else
                this.facetedData.showedTopics[idxTopic].amount += 1
        })
    }

    openDialogRectifyTopic(element): void {
        this.openDialog(DialogRectifyTopicComponent,
            { text: element.text, topic: element.topic, token: this.token })
    }

    openDialogRectifySentiment(element): void {
        this.openDialog(DialogRectifySentimentComponent,
            { text: element.text, sentiment: element.sentiment, token: this.token })
    }

    private openDialog(_class, data): void {
        const dialogRef = this.dialog.open(_class, { data });
        dialogRef.afterClosed().subscribe(_result => { });
    }

    reportWrongSentiment(element) {
        this._snackBar.open('Gracias por su reporte :)', 'OK', { duration: 3000 });
        console.log(['Wrong sentiment', element])
    }
}
